// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-storage"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 20.9997H3V3H15.375L21 8.62489V20.9997Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 3L7.5 3.00035V8.62524H12V3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 13H16M8 16H12M7.5 3.00035L12 3V8.62524H7.5V3.00035Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 20.9997H3V3H15.375L21 8.62489V20.9997Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemStorageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-storage',
    ref,
    icon: element,
  },
));

SystemStorageIcon.displayName = 'SystemStorageIcon';

export default SystemStorageIcon;
